import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
// import Wave from "../../../../Assets/Img/wave.png";
import Navbar from "../../../Atoms/Navbar";
// import PersonalInfoimg from "../../../../Assets/Img/personalinfoimg.png";
// import Documentimg from "../../../../Assets/Img/documentimg.png";
// import Employmentimg from "../../../../Assets/Img/employmentimg.png";
import Questions from "../../../Atoms/Question";
import analytics from '../../../../firebase.config';

import { getAnalytics, logEvent } from "firebase/analytics";

const EditFormErrorScreen = (props) => {

  const [showPersonalDetailForm, setShowPersonalDetailForm] = useState(false);


  const PersonalInformationModel = () => {
    // Get the modal
    var modal = document.getElementById("PersonalInformationModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  };
  const EmploymentDetailsModel = () => {
    // Get the modal
    var modal = document.getElementById("EmploymentDetailsModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  };
  const DocumentsAttachmentModel = () => {
    // Get the modal
    var modal = document.getElementById("DocumentsAttachmentModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  };

  const handlePersonalDetailForm = () => {
    localStorage.setItem("editFormStatusForReturnOnOtp", "true");
    { }
    localStorage.setItem("editFormStatus", "false");


    logEvent(analytics, 'dashb_otp_rejected_press_edit_form');
    window.location.href = '/AOF'
  }
  const handleWhatsapp = () => {
    window.open('https://api.whatsapp.com/send/?phone=923146398227&text&app_absent=0', '_blank').focus();
  }
  return (
    <>


      <>

        <Navbar />
        <div className="bg-color">
          <div className="container pt-3">
            <div className="row">
              <div className="col-md-7">
                <div className="bg-white mt-3 edge-welcome p-4">
                  <h2>Verification Failed</h2>
                  <p className="text-gray mt16">

                    An error occurred in the verification with the following details: <br /> <br />

                    <b>{props?.errorMessage} </b> <br /> <br />

                    In order to correct the error please either edit the form or contact customer support for assistance. <br /> <br />
                  </p>

                  <div className="d-block d-md-flex wMd100">
                    <button
                      type="button"
                      // onClick={openModalToVerifyOtp}
                      className="NavButton btn mb-2 px-3 py-2"
                      // data-toggle="modal"
                      // data-target="#exampleModal"
                      onClick={() => handlePersonalDetailForm()}
                    >
                      Edit Form
                    </button>


                    <button className="rejected btn ms-md-2 mb-2 Bold">
                      Verification failed
                    </button>
                  </div>
                </div>
                <div className="bg-white d-none d-md-block">
                  {/* <img src={Wave} className="w-100" /> */}
                  <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/wave.png" className="w-100" />
                </div>
              </div>
              <div className="col-md-4 mt-3">
                <Questions errormessage={props?.errorMessage} />
                {/* <div className="bg-Pink edge px-5 px-md-3 px-lg-5 py-3">
                  <h3 className="me-auto text-white fs16 fw-800">Questions?</h3>
                  <p className="heading">
                    Don't hesitate to contact our support team on the following
                    channels.
                </p>
                  <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                    <p
                      className="text-white fs-small"
                      style={{ fontWeight: "1000" }}
                    >
                      UAN
                  </p>
                    <p className="ms-auto text-white fs-small fw-bold">
                      021 111 639 825 Ext147
                  </p>
                  </div>
                  <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                    <p
                      className="text-white fs-small"
                      style={{ fontWeight: "1000" }}
                    >
                      WhatsApp
                  </p>
                  <p className="ms-auto text-white fs-small fw-bold " >
                 <a className="text-white" onClick={() => handleWhatsapp()}>+92 314 NEXTCAP (6398227)</a> 
                  </p>
                  </div>
                  <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                    <p
                      className="text-white fs-small"
                      style={{ fontWeight: "1000" }}
                    >
                      Email
                  </p>
                    <p className="ms-auto text-white fs-small fw-bold">
                      cs@nextcapital.com.pk
                  </p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="modal" tabIndex="-1" role="dialog" id="myModal">
          <div className="modal-dialog centerr p-0" role="document">
            <div className="modal-content">
              <div className="modal-header p-0">
                <h5 className="modal-title t-pink">Information Submited</h5>

                <span className="close cross">&times;</span>
              </div>
              <div className="modal-body px-0">

                <p className="fw-500 fs16 ms-auto t-grey-400 cursorPointer">
                  Thank You For Submiting Your From
                </p>
              </div>
              <div className="modal-footer px-0">
                <NavLink to="/Otp">
                  <button
                    type="button"
                    className="btn-outlined fs16 px-3 py-2 mx-2 close"
                    data-dismiss="modal"
                  >
                    OK
                  </button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          id="PersonalInformationModal"
        // style={{backgroundColor:"grey"}}
        >
          <div className="modal-dialog centerr p-0" role="document">
            <div className="modal-content container">
              <div className="modal-body text-center my-3 ">
                {/* <img src={PersonalInfoimg} /> */}
                <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/personalinfoimg.png" className="w-100" />
              </div>
              <div className="modal-body text-center mb-3 ">

                <p className="t-grey-800 fw-800 ls4 fs32">Personal Information</p>
                <p className="fw-lighter t-grey-200 fs16">
                  NCCPL, SECP & CDC requires us to collect your National Identity
                  Card information and KYC information.This is need to verify your
                  identity, employment and proof of income.
                </p>
                <div className="d-inline-flex">
                  <p className='mdl-step active mx-2 text-center'></p>
                  <p className='mdl-step mx-2 text-center'></p>
                  <p className='mdl-step mx-2 text-center'></p>
                </div>
                <button
                  className="my-3 py-3 edge w-100 NavButton btn border-0 close"
                  onClick={() => EmploymentDetailsModel()}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          id="EmploymentDetailsModal"
        >
          <div className="modal-dialog centerr p-0" role="document">
            <div className="modal-content container">
              <div className="modal-body text-center my-3 ">
                {/* <img src={Employmentimg} /> */}
                <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/employmentimg.png" />
              </div>
              <div className="modal-body text-center mb-3 ">

                <p className="t-grey-800 fw-800 ls4 fs32">Employment Details</p>
                <p className="fw-lighter t-grey-200 fs16">
                  NCCPL and SECP requires you to provide your employment
                  information sch as employment details and employment address and
                  other valuable details.
                </p>
                <div className="d-inline-flex">
                  <p className='mdl-step mx-2 text-center'></p>
                  <p className='mdl-step active mx-2 text-center'></p>
                  <p className='mdl-step mx-2 text-center'></p>
                </div>
                <button
                  className="my-3 py-3 edge w-100 NavButton btn border-0 close"
                  onClick={() => DocumentsAttachmentModel()}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          id="DocumentsAttachmentModal"
        >
          <div className="modal-dialog centerr p-0" role="document">
            <div className="modal-content container">
              <div className="modal-body text-center my-3 ">
                {/* <img src={Documentimg} /> */}
                <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/documentimg.png" />
              </div>
              <div className="modal-body text-center mb-3 ">

                <p className="t-grey-800 fw-800 ls4 fs32">Doccument Attachments</p>
                <p className="fw-lighter t-grey-200 fs16">
                  Keep your documents in handy. You'll need to submit them as a
                  source of verification of your identity, employment and proof of
                  income.
                </p>
                <div className="d-inline-flex">
                  <p className='mdl-step mx-2 text-center'></p>
                  <p className='mdl-step mx-2 text-center'></p>
                  <p className='mdl-step active mx-2 text-center'></p>
                </div>
                <NavLink to="/AOF">
                  <button className="my-3 py-3 edge w-100 NavButton btn  border-0">

                    Continue
                  </button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </>


    </>
  );
};

export default EditFormErrorScreen;
